import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { MobileMenu, NAV_LINKS } from "./MobileMenu";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
      className="fixed top-0 left-0 w-full z-50"
      data-testid="navbar"
    >
      <div className="plaid h-2.5 w-full" aria-hidden="true" data-testid="navbar-plaid-strip" />
      <div className="backdrop-blur-xl bg-white/80 border-b border-black/[0.08]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand-link"
          className="font-display font-medium text-2xl md:text-3xl tracking-[0.2em] uppercase whitespace-nowrap text-[#493E38]"
        >
          Mont Elk
        </a>
        <nav className="flex items-center gap-8 md:gap-12 text-[11px] md:text-xs font-medium tracking-[0.25em] uppercase">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.testid}-link`}
              className="hidden md:block text-[#908B85] hover:text-[#493E38] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-enquire-button"
            className="hidden md:block px-6 py-2.5 rounded-full bg-[#DBB89C] text-white hover:bg-[#493E38] transition-colors duration-300"
          >
            Enquire
          </a>
          <button
            type="button"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-menu-button"
            className="md:hidden p-2 -mr-2 text-[#493E38]"
          >
            {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
          </button>
        </nav>
      </div>
      <MobileMenu open={open} onClose={() => setOpen(false)} />
      </div>
    </motion.header>
  );
};
